module.exports = require('./dist/SAlert');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-s-alert/index.js
// module id = 321
// module chunks = 0